module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/room-path-solid-2028429f5d28b7bf3fb1b6d0af9c7f00.svg";